import CookItAtHome, { CookItAtHomeProps } from "./CookItAtHome";

export { CookItAtHome, CookItAtHomeProps };

export default CookItAtHome;
